import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import InventoryGroup from 'components/Profile/components/ProfileInventoryGroups/InventoryGroup';
import { IAppState } from 'types/app';
import { IQuality } from 'types/qualities';
import sortInPossessionsTabOrder from './sortInPossessionsTabOrder';

const withSortedPossessions = (group: { name: string, possessions: IQuality[] }) => ({
  ...group,
  possessions: sortInPossessionsTabOrder(group.possessions),
});

type Props = ReturnType<typeof mapStateToProps>;

function ProfileInventoryGroups({ profile }: Props) {
  if (!profile.expandedEquipped || !profile.standardEquipped) {
    return null;
  }

  const expandedEquipped = withSortedPossessions(profile.expandedEquipped);
  const standardEquipped = withSortedPossessions(profile.standardEquipped);
  return (
    <Fragment>
      <div className="profile__inventory-group-container">
        <InventoryGroup
          data={standardEquipped}
          hideHeadings
          overrideLevels
          profile
        />
      </div>
      <div className="profile__inventory-group-container">
        <InventoryGroup
          data={expandedEquipped}
          hideHeadings
          overrideLevels
          profile
        />
      </div>
    </Fragment>
  );
}

ProfileInventoryGroups.displayName = 'ProfileInventoryGroups';

const mapStateToProps = ({ profile }: IAppState) => ({
  profile,
});

export default connect(mapStateToProps)(ProfileInventoryGroups);